import { Tabs } from 'antd';
import React from 'react';
import HolisticProjectReportsTypeTab from './HolisticQuarterlyReportsTypeTab';
import { useHistory, useParams } from 'react-router-dom';
import { useState } from 'react';

function HolisticProjectReportsTabs({ holisticProjectId, baseUrl }) {
  const { reportCategory } = useParams();
  const history = useHistory();
  const activeReportStatus = {
    pending: 'PENDING',
    approved: 'APPROVED',
    hold: 'HOLD',
    draft: 'DRAFT',
    rejected: 'REJECTED',
  }[reportCategory];
  const [sharedFilters, setSharedFilters] = useState({
    peopleGroupId: undefined,
    regionCode: undefined,
    projectCoordId: undefined,
    projectNumberSearch: '',
    frequency: 'ALL',
  });

  return (
    <Tabs
      defaultActiveKey="pending"
      activeKey={reportCategory}
      onChange={(key) => history.push(`${baseUrl}/${key}`)}
    >
      <Tabs.TabPane tab="Pending" key="pending">
        <HolisticProjectReportsTypeTab
          reportStatus="PENDING"
          activeReportStatus={activeReportStatus}
          holisticProjectId={holisticProjectId}
          sharedFilters={sharedFilters}
          onSharedFiltersChange={setSharedFilters}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Approved" key="approved">
        <HolisticProjectReportsTypeTab
          reportStatus="APPROVED"
          activeReportStatus={activeReportStatus}
          holisticProjectId={holisticProjectId}
          sharedFilters={sharedFilters}
          onSharedFiltersChange={setSharedFilters}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab="On Hold" key="hold">
        <HolisticProjectReportsTypeTab
          reportStatus="HOLD"
          activeReportStatus={activeReportStatus}
          holisticProjectId={holisticProjectId}
          sharedFilters={sharedFilters}
          onSharedFiltersChange={setSharedFilters}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Drafts" key="draft">
        <HolisticProjectReportsTypeTab
          reportStatus="DRAFT"
          activeReportStatus={activeReportStatus}
          holisticProjectId={holisticProjectId}
          sharedFilters={sharedFilters}
          onSharedFiltersChange={setSharedFilters}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Rejected" key="rejected">
        <HolisticProjectReportsTypeTab
          reportStatus="REJECTED"
          activeReportStatus={activeReportStatus}
          holisticProjectId={holisticProjectId}
          sharedFilters={sharedFilters}
          onSharedFiltersChange={setSharedFilters}
        />
      </Tabs.TabPane>
    </Tabs>
  );
}

export default HolisticProjectReportsTabs;
